import { Utils } from "../utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface ICoords {
    lat: number;
    lng: number;
}

export class Coords implements ICoords {

    constructor(data?: ICoords) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: ICoords) {
        mapData(data, { root: () => this });
    }

    lat: number = 0;
    lng: number = 0;

}